/**
 * Constants definition.
 *
 * @type {{IRM: string}}
 */
const ALLOW_STEP_BACK = {
  IRM: 'IRM',
  ONAT: 'ONAT',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const ALLOW_STEP_BACK_ENUM = Object.keys(ALLOW_STEP_BACK);

const IRM = ALLOW_STEP_BACK_ENUM[0];

export {
  ALLOW_STEP_BACK_ENUM,
  ALLOW_STEP_BACK,
  IRM,
};
